import { UPDATE_SEGMENTS } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => (dispatch) =>
    dispatch(actions[UPDATE_SEGMENTS](values));
